import { render } from "./DocumentationMenu.vue?vue&type=template&id=084d35d6&scoped=true"
import script from "./DocumentationMenu.vue?vue&type=script&lang=js"
export * from "./DocumentationMenu.vue?vue&type=script&lang=js"

import "./DocumentationMenu.vue?vue&type=style&index=0&id=084d35d6&scoped=true&lang=css"
import "./DocumentationMenu.vue?vue&type=style&index=1&id=084d35d6&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-084d35d6"]])

export default __exports__